import React, { useEffect, useState } from "react";
import "../../../style/main.scss";
import Dropdown from "react-bootstrap/Dropdown";
import { Icon } from "@iconify/react";

import axios from "axios";
import { toast } from "react-toastify";

import { SpinnerCircular } from "spinners-react";
import "react-phone-number-input/style.css";
import { BiPhoneIncoming } from "react-icons/bi";

const CreateScript = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [scriptResponse, setScriptResponse] = useState([]);
  const [convertedScriptResponse, setConvertedScriptResponse] = useState("");

  const [knowledgeAgents, setKnowledgeAgents] = useState([]);
  const [selected, setSelected] = useState("Connect A Knowledge Base");

  const [initialMessage, setInitialMessage] = useState("");

  const [voiceSelect, setVoiceSelection] = useState("NFG5qt843uXKj4pFvR7C");

  function checkValidation() {
    var error = false;
    // if (!receiverName || receiverName == "" || receiverName == undefined) {
    //   error = true;
    //   toast.warning("Please enter a valid name", { toastId: "errorName" });
    // }
    // if (
    //   !receiverPhone ||
    //   receiverPhone == "" ||
    //   receiverPhone == undefined ||
    //   !isValidPhoneNumber(receiverPhone)
    // ) {
    //   toast.warning("Please enter a valid phone number", {
    //     toastId: "errorPhone",
    //   });
    //   error = true;
    // }
    if (initialMessage === "") {
      toast.warning("Please Enter initial message", {
        toastId: "errorInputs",
      });
      error = true;
    }
    if (convertedScriptResponse === "") {
      toast.warning("Please Enter script !!", {
        toastId: "errorInputs",
      });
      error = true;
    }
    return error;
  }

  function saveScript() {
    try {
      if (checkValidation()) {
      } else {
        setIsLoading(true);
        const label =
          "Strictly don't Bold the response, Your response should be in string but don't use any symbols or special characters in the response.";
        let config = {
          method: "POST",
          url: `${process.env.REACT_APP_PYTHON_API}/set_inbound_prompt?prompt=${
            convertedScriptResponse + label
          }&initial_message=${initialMessage}&voice_id=${voiceSelect}`,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        };
        axios
          .request(config)
          .then((response) => {
            console.log(JSON.stringify(response.data));
            setIsLoading(false);
            alert("Prompt Saved !!");
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
            if (error?.response?.data?.detail) {
              toast.error(error?.response?.data?.detail, {
                toastId: "promptSaveError",
              });
            } else {
              toast.error("Error while saving. Please check console logs", {
                toastId: "promptSaveError",
              });
            }
          });
      }
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      toast.error("Error while saving", { toastId: "promptSaveError" });
    }
  }

  return (
    <div>
      {isLoading && (
        <>
          <div className="loader">
            <SpinnerCircular
              color="#ffffff"
              size={"20%"}
              thickness={150}
              secondaryColor="#32C0BE"
            />
            <span className="customLoadingText">Loading...</span>
          </div>
        </>
      )}
      <div className="create-script">
        <div className="script-content">
          <div className="right-create-script">
            <div className="inner-content w-100">
              {/* <div className="content">
                <Icon icon="arcticons:nrf-connect" width="24" height="24" />
                <Dropdown>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    {selected != "Connect A Knowledge Base"
                      ? `Connected to ${selected.name}`
                      : selected}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {knowledgeAgents.length > 0 ? (
                      knowledgeAgents.map((agent) => (
                        <Dropdown.Item onClick={() => setSelected(agent)}>
                          {agent.name}
                        </Dropdown.Item>
                      ))
                    ) : (
                      <Dropdown.Item>No Knowledgebase Found</Dropdown.Item>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </div> */}
              <div className="content">
                <Icon
                  icon="solar:user-speak-rounded-broken"
                  width="24"
                  height="24"
                />
                <div className="special">
                  <label htmlFor="1">
                    <div className="male">
                      Male
                      <input
                        type="radio"
                        name="voice-select"
                        id="1"
                        value="NFG5qt843uXKj4pFvR7C"
                        defaultChecked
                        onChange={(e) => {
                          setVoiceSelection(e.target.value);
                        }}
                      />
                    </div>
                  </label>
                  <label htmlFor="2">
                    <div className="female">
                      Female
                      <input
                        type="radio"
                        name="voice-select"
                        id="2"
                        value="kPzsL2i3teMYv0FxEYQ6"
                        onChange={(e) => {
                          setVoiceSelection(e.target.value);
                        }}
                      />
                    </div>
                  </label>
                </div>
              </div>
              <div className="content">
                <BiPhoneIncoming size={23} />
                <div className="special">Phone: +1 2132053820</div>
              </div>
            </div>
            <div className="inner-btn">
              <button onClick={saveScript} className="w-100 gap-3">
                Save Script
              </button>
            </div>
          </div>
          <div className="left-create-script">
            <h2 className="text-orange-gradient">Create Script</h2>

            <div />

            <div className="scroll-text">
              <input
                type="text"
                placeholder="Enter initial message, eg: Hey Alex !"
                onChange={(e) => {
                  setInitialMessage(e.target.value);
                }}
                value={initialMessage}
                className="hey"
              />

              <div className="responsegpt">
                {scriptResponse && (
                  <>
                    <p style={{ color: "#d7d7d7" }}>
                      Wait for the Prospect to Respond
                    </p>
                    <textarea
                      wrap="hard"
                      rows={25}
                      placeholder="Enter script here..."
                      className="gptcontent"
                      style={{ resize: "none" }}
                      onChange={(e) =>
                        setConvertedScriptResponse(e.target.value)
                      }
                      value={convertedScriptResponse}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateScript;
